import { Game } from 'app-types';
import { VideoLike, KitchenSinkRowItem } from 'store-types';

export const isGameFinal = (game: Game): boolean => {
  return game.statusDesc === 'FINAL';
};

export const teamNamesExist = (game: Game): boolean => {
  return !!(
    (game.awayTeam.nickName || game.awayTeam.name) &&
    (game.homeTeam.nickName || game.homeTeam.name)
  );
};

export const shouldDisplayTile = (game: Game | null | undefined): boolean => {
  return !!game && isGameFinal(game) && !!teamNamesExist(game);
};

export const getHighlightsRowData = (row: KitchenSinkRowItem, games: Game[] | null): VideoLike[] => {
  if (!row.data) return [];
  return (row.data as VideoLike[]).filter((item: VideoLike) =>
    shouldDisplayTile(getGamebyVideo(item, games)),
  );
};

export const getGamebyVideo = (video?: VideoLike, games: Game[] | null | undefined = null): Game | null => {
  let game = null;
  const { gameId } = video?.properties ?? {};
  if (gameId != null && games != null) {
    game = games.find(i => i.id === gameId);
  }
  return game ?? null;
};
